<template>
  <div class="outBox">
    <!-- <van-nav-bar @click-left="$router.go(-1)" left-arrow /> -->
    <!-- <van-nav-bar
      right-text="订阅历史"
      @click-right="$router.push('/orderlist')"
    /> -->
    <van-loading style="position:fixed;margin:0 auto;left:50%;top:30%;transform:translate(-50%,0)" color="#1989fa" size="24px" v-show="loading" vertical>
      <div style="color:#1989fa;">
        加载中...
      </div>
    </van-loading>
    <div v-if="status == 2" class="flex tab m-auto">
      <div v-for="(item, index) in tabList" :key="index" @click="changeTab(item.id, item.schoolId)" :class="type === item.id ? 'select' : ''">
        {{ item.name }}
      </div>
    </div>
    <div class="wrap">
      <div class="wrap-content">
        <div class="vip-card-list">
          <div class="vip-icon" v-if="isVip">
            <img src="@/assets/vip-01.png" alt="" />
          </div>
          <!-- 进入短视频订阅历史页 -->
          <div class="history" @click="$router.push('/orderlist')">
            订单历史
          </div>
          <div class="title">
            <div class="t-1">{{ tabList[type].desc }}</div>
            <div class="t-2">
              {{ desc }}
              <!-- 购买订阅服务，您可以接收家长、孩子进出学校的消息及进出学校8秒视频 -->
            </div>
            <div class="t-2" style="color: #c29f55">
              <van-radio-group v-model="childRadio" @change="childrenRadio">
                <div v-for="item in $store.state.vipData" :key="item.childrenName" style="margin-bottom: 0.3rem">
                  <!-- <input
                    type="radio"
                    :value="item.id"
                    name="radioes"
                    v-model="childRadio"
                    class="radiotext"
                  /> -->
                  <span>
                    <van-radio :name="item.id" class="childText" :class="item.status == 1 ? 'cancelChild' : ''">
                      <span>{{ item.name }}</span>
                      <span style="margin: 0 0.45rem; ">{{ item.schoolName }}</span>
                      <span>{{ item.className }}</span>
                      <template #icon="props">
                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                      </template>
                    </van-radio>
                    <span class="viptext">
                      {{ item.status == 1 ? "未订阅" : item.status == 0 && item.type == 0 ? "消息订阅到期时间：" + getDateYMD(item.expireDate) : item.status == 0 && item.type == 1 ? "消息订阅已开通" : item.status == 2 && item.type == 0 ? "视频订阅到期时间：" + getDateYMD(item.expireDate) : item.status == 2 && item.type == 1 ? "视频订阅已开通" : "" }}
                    </span>
                  </span>
                  <!-- <span v-else>
                    <van-radio :name="item.id">
                      <span style="color: #f96767">{{ item.name }}</span>
                      <span style="margin: 0 0.45rem; color: #f96767">{{
                        item.schoolName
                      }}</span>
                      <span style="color: #f96767">{{ item.className }}</span>
                      <template #icon="props">
                        <img
                          class="img-icon"
                          :src="props.checked ? activeIcon : inactiveIcon"
                        />
                      </template>
                    </van-radio>
                    <span class="viptext">未订阅</span>
                  </span> -->
                </div>
              </van-radio-group>
            </div>
            <!-- <div
              class="t-2"
              v-for="item in $store.state.vipData"
              :key="item.childrenName"
              style="color:#c29f55"
            >
              <div v-if="item.dueTime">
                <van-radio
                  style="margin-bottom:0.3rem"
                  >{{  item.childrenName }}
                  {{ getDateYMD(item.dueTime) }}到期
                </van-radio>

                 {{ item.childrenName }}&nbsp;已开通
                {{ getDateYMD(item.dueTime) }} 到期
              </div>
              <div v-else style="color:#F96767">
                 <van-radio
                  style="margin-bottom:0.3rem;color:#F96767"
                  >
                  {{ item.childrenName }}&nbsp;未开通
                  </van-radio>
              </div>
            </div> -->
          </div>
          <van-empty description="您的孩子没有服务可供选择" v-show="!loading && (!vipCard || vipCard.length < 1)"></van-empty>
          <div class="horizontal-container" v-if="vipCard && vipCard.length > 0">
            <div class="scroll-wrapper" ref="scroll">
              <!--  -->
              <div class="scroll-content">
                <div v-for="(item, index) in vipCard" :class="['scroll-item', { active: vipItemIndex == index }]" :key="index" @click="handleSelectVipItem(item, index)">
                  <div class="item-title">
                    {{ item.productName }} <span v-if="item.productName.indexOf('一次') == -1">/{{ item.duration }}个月</span>
                  </div>

                  <div class="discounts">{{ item.productDescribe }}</div>
                  <div class="price " :class="item.productName.indexOf('一次') !== -1 ? 'mt2' : ''">
                    ￥<span>{{ item.price / 100 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" v-if="vipCard && vipCard.length > 0">
            <div class="card-title" v-show="tabList[type].status == 0">选择几个家长</div>
            <div class="card-title" v-show="tabList[type].status == 1">绑定家长数</div>
            <div class="card-body">
              <div class="card-list">
                <div class="card-list-item" @click="handleSelectComboItem(item, index)" :class="{ active: selectComboIndex == index }" v-for="(item, index) in combo" :key="index">
                  <div class="card-list-item-icon">
                    <img :src="item.iconUrl" alt="" class="" />
                    <!-- <img src="https://asiait-ai.oss-cn-beijing.aliyuncs.com/1603695008000.jpg" alt="" v-show="tabList[type].status==1" /> -->
                  </div>
                  <div class="card-info">
                    <div class="card-t-1">{{ item.packageName }}</div>
                    <div class="card-t-2">{{ item.discountName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <BindPerson
            ref="bindPerson"
            v-show="selectComboIndex != -1 && comboItem.peopleNum != 1"
            :peopleNum="comboItem.peopleNum"
          /> -->
        </div>
      </div>
    </div>
    <div class="agree" v-if="vipCard && vipCard.length > 0">
      <van-checkbox
        v-model="checked"
        shape="square"
        style="
          font-size: 0.8rem;
          padding: 0.6rem 0 7rem 1.3rem;
          background: white;
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.1);
        "
      >
        我已阅读并同意
        <span style="color: #c29f55" @click="$router.push('/serviceAgreement')">《订阅服务协议》</span>
      </van-checkbox>
      <van-tabbar style="border: white; padding-bottom: 2rem; padding-top: 1rem">
        <div style="padding-bottom: 1rem; clear: both">
          <div class="sumTotal">
            合计：<span class="money"
              >￥<span style="font-size: 1.65rem">{{ (this.realPrice / 100).toFixed(2) }}</span></span
            >
            <div style="color: #666666">
              <span> 已优惠：￥{{ ((originalPrice - realPrice) / 100).toFixed(2) }} </span>
              <span style="color: #c29f55; margin-left: 0.7rem" @click="showPopup">明细<img src="@/assets/up.png"/></span>
            </div>
          </div>
          <!-- 立即订阅，如果用户选择了一次性订阅且一次性订阅已经购买过了，则立即订阅按钮禁用 -->
          <div class="btn" @click="payOrder" v-show="onePayed == 2||onePayed ==0||onePayed == 3&& !payLoading">确认支付</div>
          <div class="btn" v-show="onePayed == 0 && payLoading">下单中...</div>
          <div class="btn disabled" v-show="onePayed ==1">已订阅无需再次付款</div>
        </div>
      </van-tabbar>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30.5%' }">
      <div class="pop">
        原价：<span style="margin-left: 0.75rem">￥{{ (originalPrice / 100).toFixed(2) }}</span>
      </div>
      <div class="pop">
        已优惠：<span>￥{{ ((originalPrice - realPrice) / 100).toFixed(2) }}</span>
      </div>
      <div class="pop">
        合计：<span style="margin-left: 0.75rem">￥{{ (this.realPrice / 100).toFixed(2) }}</span>
      </div>
      <div class="agree">
        <!-- <van-checkbox
          v-model="checked"
          shape="square"
          style="
            font-size: 0.8rem;
            padding: 0.6rem 0 7rem 1.3rem;
            background: white;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
          "
        >
          我已阅读并同意
          <span
            style="color: #c29f55"
            @click="$router.push('/serviceAgreement')"
            >《订阅服务协议》</span
          >
        </van-checkbox> -->
        <van-tabbar style="border: white; padding-bottom: 2rem; padding-top: 1rem">
          <div style="padding-bottom: 1rem; clear: both">
            <div class="sumTotal">
              合计：<span class="money"
                >￥<span style="font-size: 1.65rem">{{ (this.realPrice / 100).toFixed(2) }}</span></span
              >
              <div style="color: #666666">
                <span> 已优惠：￥{{ ((originalPrice - realPrice) / 100).toFixed(2) }} </span>
                <span style="color: #c29f55; margin-left: 0.7rem" @click="closePopup">明细<img src="@/assets/down.png"/></span>
              </div>
            </div>
            <div class="btn" @click="payOrder" v-show="onePayed == 2||onePayed ==0||onePayed == 3">确认支付</div>
            <div class="btn disabled" v-show="onePayed ==1">已订阅无需再次付款</div>
          </div>
        </van-tabbar>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import BindPerson from "./bindPersonCurd";
import moment from "moment";
import radioChecked from "../../assets/radio_checked.png";
import radio from "../../assets/radio.png";
import wxSDK from "@/utils/wxSDK.service";

export default {
  data() {
    return {
      desc: "",
      vipItemIndex: -1,
      selectComboIndex: -1,
      vipCard: [],
      vipItem: {},
      comboItem: {},
      combo: [],
      childRadio: "",
      parentId: [],
      checked: false,
      show: false,
      vipData: [],
      activeIcon: radioChecked,
      inactiveIcon: radio,
      //切换订阅视频或订阅消息
      tabList: [
        {
          id: 0,
          name: "消息订阅",
          desc: "消息订阅服务",
          info: "购买订阅服务，您可以接收孩子进出学校的消息。",
          path: "/orderlist",
          status: 1,
        },
        {
          id: 1,
          name: "短视频订阅",
          desc: "短视频订阅服务",
          info: "购买订阅服务，您可以接收家长、孩子进出学校的消息及进出学校8秒视频",
          path: "/orderlist",
          status: 0, //0代表显示多选订阅，1代表显示一次性付费订阅
        },
      ],
      type: 0,
      schoolId: "",
      status: 0,
      userId: "",
      //设置公共值判断是否已经选择了一次性付费
      //   onePay: false,
      //设置公共值判断是否已经选择了按家长人数收费
      isByNumber: false,
      //控制当前孩子一次性订阅已经购买了
      onePayed: 0,
      //按钮未初始化之前未0，控制单选框的点击事件选择
      yjEd: false,
      //获取一次性订阅的套餐列表
      onceCombo: [],
      //订单价格
      productPrice: "",
      loading: true,
      payLoading: false,
      mobile: "",
    };
  },
  mounted() {
    // console.log('我是用户信息');
    // console.log(JSON.parse(localStorage.getItem('userInfo')));
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.mobile = JSON.parse(localStorage.getItem("userInfo")).mobile;
    this.childRadio = this.$route.params.id;
    // console.log('我是传过来的内容');
    if (this.$route.params && this.$route.params.schoolId) {
      this.childRadio = this.$route.params.id;
      this.schoolId = this.$route.params.schoolId;
      localStorage.setItem("vipSchoolId", this.schoolId);
      localStorage.setItem("vipRadio", this.childRadio);
    } else {
      this.schoolId = localStorage.getItem("vipSchoolId");
      this.childRadio = localStorage.getItem("vipRadio");
    }
    // document.title='视频订阅'
    // this.schoolId=JSON.parse(localStorage.getItem('userInfo')).schoolId;
    if (this.schoolId) {
      this.getSchoolPayStatus();
    }
    // this.getPackageList();
    this.init();
    this.getParentsPayAuthChildrenList();
  },
  computed: {
    originalPrice() {
      return this.isByNumber ? this.vipItem.price * this.comboItem.peopleNum || 0 : this.vipItem.price;
      //   return this.onePay ? this.vipItem.price : this.vipItem.price * this.comboItem.peopleNum || 0;
    },
    realPrice() {
      return this.isByNumber ? this.vipItem.price * this.comboItem.peopleNum * this.comboItem.discount || 0 : this.vipItem.price;
      //   return this.onePay ? this.vipItem.price : this.vipItem.price * this.comboItem.peopleNum * this.comboItem.discount || 0;
    },
    isVip() {
      console.log(this.$store.state.vipData);
      return this.$store.state.vipData.some((item) => item.expireDate);
    },
  },
  components: {
    BindPerson,
  },
  methods: {
    personItemData(obj) {
      return {
        bandingUserName: obj.name,
        bandingUserId: obj.id,
        schoolId: obj.schoolId,
        bandingUserPhone: obj.mobile,
        isShowList: obj.isShowList,
      };
    },
    //确认支付
    async payOrder() {
      if (this.checked == false) {
        this.$toast({
          message: '您需要先勾选"我已阅读并同意《订阅服务协议》"',
          position: "bottom",
        });
        return;
      }
      if (Object.keys(this.vipItem).length == 0) {
        this.$toast("请选择会员");
        return;
      }
      if (Object.keys(this.comboItem).length == 0) {
        this.$toast("请选择套餐");
        return;
      }
      this.payLoading = true;
      const { productName, duration, price, id: productId } = this.vipItem;
      const { packageName, peopleNum, discount, id: packageId } = this.comboItem;
      console.log(productId, packageId, "产品或套餐");
      this.parentId = this.vipData.filter((item) => item.id == this.childRadio);
      console.log(this.parentId, "this.parentId");
      //   const originalPrice = this.onePay ? (price / 100).toFixed(2) : ((price / 100) * peopleNum).toFixed(2);
      const originalPrice = this.isByNumber ? ((price / 100) * peopleNum).toFixed(2) : (price / 100).toFixed(2);
      console.log(originalPrice, "originalPrice");
      const realPrice =this.isByNumber ? (originalPrice * discount).toFixed(2):(originalPrice * 1).toFixed(2);
      console.log(realPrice, "realPrice");
      try {
        const result = await this.$https.createOrder({
          originalPrice: originalPrice * 100,
          realPrice: realPrice * 100,
          productId: productId,
          packageId: packageId,
          userId: this.parentId[0].parentId,
          userMobile: this.mobile,
          schoolId: this.parentId[0].schoolId,
          childrenId: this.childRadio,
          bandingSaveDTOS: [],
        });
        if (result.code !== 200) {
          this.payLoading = false;

          this.$toast(result.msg);
          return;
        }
        this.payLoading = false;
        const { data, code, msg } = await this.$https.createPayOrder({
          outTradeNo: result.data,
        });
        if (code !== 200) {
          this.payLoading = false;

          // this.btn_loading_text = ''
          this.$toast(`下单失败`);
          return false;
        }
        const jsinit = await wxSDK.jsSDKConfig();
        if (jsinit == "err") {
          this.$toast("微信sdk初始化失败，请重试");
          return false;
        }
        const resultPay = await wxSDK.chooseWXPay(data);
        this.payLoading = false;

        if (resultPay == "支付失败") {
          this.payLoading = false;
          this.$toast("支付失败");
        } else if (resultPay == "支付取消") {
          // 跳转订单列表
          this.$toast("支付取消");
          this.payLoading = false;
        } else {
          // 支付成功
          console.log("支付成功-----", resultPay);
          /**注意此位置
           *
           * 更新订单日后还要作
           * */

          // let update=await this.$https.updateOrder({
          //   bandingSaveDTOS: [...this.person]
          // })
          const res = await this.$https.getPayOrder({
            outTradeNo: result.data,
          });
          //  bandingSaveDTOS: [...this.person]
          if (res.code !== 200) {
            this.payLoading = false;
            this.$toast("查询支付结果失败");
            return;
          }
          this.payLoading = false;
          this.$toast("支付成功");
          setTimeout(() => {
            this.$router.push("/orderList");
          }, 1000);
          console.log("查询支付状态", res);
        }
        this.payLoading = false;
        // this.btn_loading_text = "提交订单";
      } catch (error) {
        this.payLoading = false;
        // this.btn_loading_text = "提交订单";
        console.log("下单失败-----", error);
        this.$toast("下单失败，请重试");
      }
    },
    //选择商品若商品中有一次性商品则触发查询套餐
    async getPackageOnce(type) {
      const { code, data } = await this.$https.getPackageOnce({ schoolId: this.schoolId, type });
      if (code !== 200) return;
      if (!data || data.length < 1) {
        this.combo = [];
        return;
      }
      console.log(data, "data");
      const defaultIndex = data.findIndex((item) => item.isDefault == 1);
      if (defaultIndex !== -1) {
        this.selectComboIndex = defaultIndex;
        this.comboItem = data[defaultIndex];
      }
      this.combo = data.map((item) => {
        console.log(item, "选择商品若商品中有一次性商品则触发查询套餐");
        item.discountName = item.discount == 1 ? "原价" : (item.discount * 10).toFixed(2) + "折";
        return item;
      });
      console.log(this.combo, "this.combo");
    },
    //获取状态(0显示一个tab,1显示两个tab)
    async getSchoolPayStatus() {
      const { code, data } = await this.$https.getSchoolPayStatus({ schoolId: this.schoolId });
      if (code !== 200) {
        this.loading = false;
        return;
      }
      // console.log('我是获取到的状态');
      // console.log(data);
      if (data === 0) {
        document.title = "消息订阅";
        this.type = data;
      } else if (data === 1) {
        this.type = data;
      }
      this.status = data;
      this.loading = false;
      this.getVipList();
    },
    //切换tab栏
    changeTab(id, schoolId) {
      this.type = id;
      //   this.onePay = false;
      this.isByNumber = false;
      this.selectComboIndex = -1;
      this.comboItem = "";
      this.vipItemIndex = -1;
      this.vipItem = "";
      this.getVipList();
    },
    showPopup() {
      this.show = true;
    },
    closePopup() {
      this.show = false;
    },
    init() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        click: true,
        probeType: 3, // listening scroll hook
      });
    },
    getDateYMD(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    //获取商品列表
    async getVipList() {
      // String(this.type)
      const { code, data } = await this.$https.getVipList({ schoolId: this.schoolId, type: this.type });
      if (code !== 200) {
        this.$toast("获取会员列表失败");
        this.loading = false;
        return false;
      }
      this.vipCard = data;
      if (data && data.length > 0) {
        // data.map((item) => {
        //   console.log(item);
        //   if (item.isPersonal === 0) {
        //     this.isByNumber = true;
        //   }
        // });
        const defaultIndex = data.findIndex((item) => item.isDefault == 1);
        console.log(defaultIndex, data, "获取会员列表");
        if (defaultIndex !== -1) {
          this.vipItemIndex = defaultIndex;
          this.vipItem = data[defaultIndex];
          this.productPrice = (this.vipItem.price / 100).toFixed(2); //订单价格
          // console.log('判断是否是一次性付费');
          // console.log(this.vipItem.type);
          //   if (this.vipItem.type == 1) {
          //     //显示一次性付费
          //     this.onePay = true;
          //   } else {
          //     this.onePay = false;
          //   }
          //判断是否按家长人数收费
          if (this.vipItem.isPersonal == 0) {
            this.isByNumber = true;
          } else {
            this.isByNumber = false;
          }
          this.getPackageOnce(this.vipItem.type);
        }
        this.desc = data[0].payMassage;
        this.vipCard = data;
        //  this.$nextTick(() => {
        // console.log();
        //   this.bs&&this.bs.refresh();
        // });
        this.loading = false;
      } else {
        this.vipItemIndex = 0;
        this.vipItem = "";
        this.loading = false;
      }
    },
    async getPackageList() {
      const { code, data } = await this.$https.getPackageList({ schoolId: this.schoolId });
      if (code !== 200) {
        this.$toast("获取套餐列表失败");
        return false;
      }
      if (!data) return;
      const defaultIndex = data.findIndex((item) => item.isDefault == 1);
      if (defaultIndex !== -1) {
        this.selectComboIndex = defaultIndex;
        this.comboItem = data[defaultIndex];
      }
      this.combo = data.map((item) => {
        item.discountName = item.discount == 1 ? "原价" : item.discount * 10 + "折";
        return item;
      });
    },
    //点击某项商品列表
    handleSelectVipItem(item, index) {
      console.log(item, index, "我被点击了");
      // if (
      //   Object.keys(this.comboItem).length > 0 &&
      //   parseInt(this.comboItem.discount) != 1
      // ) {
      //   if (parseInt(item.price) < 100) {
      //     this.$toast('该套餐无法享受打折')
      //   }
      //   console.log(this.comboItem)
      // } else {
      // }
      this.productPrice = (item.price / 100).toFixed(2);
      this.desc = item.payMassage;
      //   if (item.type === 1) {
      //     // console.log('一次性购买的进来了');
      //     this.onePay = true;
      //   } else {
      //     this.onePay = false;
      //   }
      if (item.isPersonal === 0) {
        this.isByNumber = true;
      } else {
        this.isByNumber = false;
      }

      this.vipItemIndex = index;
      this.vipItem = item;
      this.getPackageOnce(item.type);
    },
    //点击套餐卡
    handleSelectComboItem(item, index) {
      if (Object.keys(this.vipItem).length > 0 && parseInt(this.vipItem.price) < 100) {
        // 第一个选择价格小于100，套餐选择不是原价
        if (item.discount !== 1) {
          this.$toast("价格大于1才能享受打折");
        } else {
          this.selectComboIndex = index;
          this.comboItem = item;
        }
        return;
      }
      this.selectComboIndex = index;
      this.comboItem = item;
      // console.log('我是comboItem');
      // console.log(this.comboItem);
    },
    //点击确认支付
    createOrder() {
      // if (this.$store.state.vipData.length > 0) {
      //   this.$toast('您已购买过会员，请勿重复购买')
      //   return
      // }
      if (this.checked == false) {
        this.$toast({
          message: '您需要先勾选"我已阅读并同意《订阅服务协议》"',
          position: "bottom",
        });
        return;
      }
      if (Object.keys(this.vipItem).length == 0) {
        this.$toast("请选择会员");
        return;
      }
      if (Object.keys(this.comboItem).length == 0) {
        this.$toast("请选择套餐");
        return;
      }
      let person = [];
      // if (
      //   this.comboItem.peopleNum >= 1 &&
      //   this.$refs.bindPerson.addPersonData.length > 0
      // ) {
      //   person = this.$refs.bindPerson.addPersonData
      // }
      sessionStorage.setItem(
        "shopping_cart",
        JSON.stringify({
          // vipItem: this.vipItem,
          // comboItem: this.comboItem,
          item: this.affirmData(),
          // person,
        })
      );
      // return;
      this.parentId = this.vipData.filter((item) => item.id == this.childRadio);
      //跳转-->订单确认
      this.$router.push({
        path: "/confirmOrder",
        query: {
          parentId: this.parentId[0].parentId,
          childId: this.childRadio,
          schoolId: this.parentId[0].schoolId,
        },
      });
    },
    affirmData() {
      const { productName, duration, price, id: productId } = this.vipItem;
      const { packageName, peopleNum, discount, id: packageId } = this.comboItem;
      //   const originalPrice = this.onePay ? (price / 100).toFixed(2) : ((price / 100) * peopleNum).toFixed(2);
      const originalPrice = this.isByNumber ? ((price / 100) * peopleNum).toFixed(2) : (price / 100).toFixed(2);
      const realPrice = this.isByNumber ? (originalPrice * discount).toFixed(2):(originalPrice * 1).toFixed(2);
      console.log("我是原价");
      console.log(originalPrice);
      console.log("我是真实价格");
      console.log(realPrice);
      const differencePrice = (originalPrice - realPrice).toFixed(2);
      return {
        // onePay: this.onePay,
        isByNumber: this.isByNumber,
        productName,
        duration,
        packageName,
        productPrice: this.productPrice,
        originalPrice,
        discount: discount == 1 ? "原价" : discount * 10 + "折",
        realPrice,
        differencePrice,
        peopleNum,
        productId,
        packageId,
        childRadio: this.childRadio,
      };
    },
    //选择孩子
    childrenRadio(e) {
      console.log("我是孩子的单选按钮", e);
      if (!e) return;
      if (this.vipData.length < 1) return;
      // console.log('我是vipData');
      // console.log(this.vipData);
      let zhi = this.vipData.find((val) => {
        return e == val.id;
      });
      this.schoolId = zhi.schoolId;
      localStorage.setItem("vipSchoolId", this.schoolId);
      // this.getVipList();
      // if(this.yjEd){
      console.log(zhi, "zhi");
        this.getUserPayStatus(e, zhi.parentId);
      if (this.schoolId) {
        this.getSchoolPayStatus();
      }
    },
    //获取家长订阅状态（用此接口来判断当前孩子是否已经订阅了，若一次性订阅了则禁止付费）
    async getUserPayStatus(childId, userId) {
      const { code, data } = await this.$https.getUserPayStatus({ childId, userId });
      if (code !== 200) return;
      //  console.log('我是获取到的家长订阅状态');
      console.log(data);
      //若为一则禁用下发商品的选择按钮
      this.onePayed = data;
      //  this.getVipList();
    },
    // 获取孩子授权列表信息
    async getParentsPayAuthChildrenList() {
      const { code, data } = await this.$https.getParentsPayAuthChildrenList({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200) {
        return;
      }
      // console.log('获取vip信息');
      // console.log(data);
      this.$store.commit("setVipData", data);
      this.childRadio = this.childRadio ? this.childRadio : data[0].id;
      this.vipData = data;
      let zhi = this.vipData.find((val) => {
        return this.childRadio == val.id;
      });
      this.getUserPayStatus(this.childRadio, zhi.parentId);
      this.yjEd = true;
      // console.log("vip", this.vipData);
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  font-size: 1rem !important;
  background: #e5e5e5;
  border: solid #e5e5e5 1px;
}
.dChild {
  color: #c29f55;
}
.childText {
  color: #c29f55;
}
.childText.cancelChild {
  span {
    color: #f96767;
  }
}
.img-icon {
  height: 15px;
}
.outBox {
  padding-top: 14px;
}
.tab {
  margin: 0px auto 0 auto;
  width: 210px;
  height: 37px;
  background: #ffffff;
  border: 1px solid #c29f55;
  opacity: 1;
  border-radius: 10px;
  > div {
    font-size: 13px;
    width: 104px;
    text-align: center;
    line-height: 36px;
    color: #c29f55;
  }
  > div:nth-of-type(1) {
    border-right: 1px solid #c29f55;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    // border-start-end-radius: 10px;
  }
  > div:nth-of-type(2) {
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  > div.select {
    color: #ffffff;
    background: #c29f55;
  }
}
.wrap {
  padding: 0.56rem 0.56rem 8rem;
  .wrap-content {
    background: #fff;
    box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.1);
    /* padding: 1.12rem 1.06rem; */
    border-radius: 0.75rem;
    margin-bottom: 2rem;

    .vip-card-list {
      position: relative;
      .vip-icon {
        position: absolute;
        left: 0;
        top: 0;
        img {
          width: 2.5rem;
          height: 2rem;
        }
      }
      .history {
        position: absolute;
        right: 1.1rem;
        top: 1rem;
        color: #1989fa;
        font-size: 0.85rem;
      }
      .title {
        /* margin-bottom: 0.94rem; */
        padding: 1.5rem 1.1rem 1.12rem 1.1rem;

        .t-1 {
          font-size: 1.12rem;
          color: #c29f55;
          font-family: Microsoft YaHei;
          font-weight: bold;
          margin-bottom: 0.4rem;
        }

        .t-2 {
          font-size: 0.87rem;
          color: #1a1a1a;
          margin-bottom: 1rem;
        }
        .viptext {
          color: #666666;
          font-size: 0.75rem;
          margin-left: 1.4rem;
          margin-top: 0.2rem;
          display: inline-block;
        }
      }
    }

    .horizontal-container {
      padding: 0rem 1rem 0.97rem 0.94rem;

      .scroll-wrapper {
        /* width: 90%; */
        /* margin: 80px auto; */
        white-space: nowrap;
        /* border: 3px solid #42b983; */
        /* border-radius: 5px; */
        overflow: hidden;

        .scroll-content {
          display: inline-block;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 0.1rem 0;
          width: 100%;
          /* height: 8.81rem; */
        }
        .scroll-item.disabled {
          background: #e5e5e5;
          border: solid #e5e5e5 1px;
        }
        .scroll-item {
          display: inline-block;
          // width: 6.38rem;
          width: 48%;
          min-height: 5.94rem;
          margin-right: 0.31rem;
          margin-bottom: 0.6rem;
          border: 0.06rem solid #f0f0f0;
          border-radius: 0.38rem;
          vertical-align: middle;
          // text-align: center;

          // padding-top: 1.25rem;
          // padding-bottom: 0.94rem;
          transition: width 0.1s ease-out;
          padding: 0.25rem 1.0125rem 0.24rem 1.0125rem;

          &.active {
            min-height: 6.82rem;
            background: #fbf4ea;
            padding: 0.69rem 1.0125rem 0.38rem 1.0125rem;

            // padding-top: 1.69rem;
            // padding-bottom: 1.38rem;
            border: 0.06rem solid #e2c993;
            box-shadow: 0rem 0.19rem 0.38rem rgba(120, 103, 14, 0.16);
          }

          .item-title {
            color: #2a2e43;
            // font-size: 0.75rem;
            font-weight: bolder;
            font-size: 0.875rem;
            // width: 4.63rem;
            white-space: break-spaces;
          }

          .price {
            color: #c29f55;
            margin-bottom: 0.44rem;
            margin-top: 0.19rem;
            text-align: right;
            span {
              font-weight: bold;
              font-size: 1.48rem;
            }
          }
          .price.mt2 {
            margin-top: 0.9rem;
          }
          .discounts {
            color: #67530d;
            margin-top: 1rem;
            font-size: 0.75rem;
            font-weight: bold;
            white-space: break-spaces;
            display: inline-block;
          }
        }
      }
    }

    .card {
      .card-title {
        color: #454f63;
        font-size: 0.88rem;
        padding: 1.06rem;
        padding-top: 0;
      }

      .bind-list {
        padding: 0 1.06rem;
        color: #454f63;

        .bind-list-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;

          &.bind-mb {
            margin-bottom: 1.19rem;
          }

          .bind-t-1 {
            width: 5rem;
            text-align: left;
            color: #454f63;
          }

          .bind-t-2 {
            width: 8rem;
            text-align: left;
            color: #454f63;
          }

          .bind-t-3 {
            text-align: center;
            width: 3.31rem;

            img {
              width: 1.05rem;
              height: 1.05rem;
            }

            &.add {
              border: 0.06rem solid #e2bd78;
              border-radius: 0.75rem;
              width: 3.31rem;
              height: 1.25rem;
              text-align: center;
              line-height: 1.25rem;
              font-size: 0.88rem;
              color: #c28f22;
            }
          }
        }
      }

      .card-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0.94rem;
        padding-bottom: 0.75rem;
        justify-content: space-between;
        .card-list-item.disabled {
          background: #e5e5e5;
          border: solid #e5e5e5 1px;
        }
        .card-list-item {
          display: flex;
          align-items: center;
          border: 0.06rem solid #efefef;
          width: 9rem;
          min-height: 3.44rem;

          //margin-right: 0.5rem;
          margin-bottom: 0.63rem;
          border-radius: 0.38rem;
          box-shadow: 0rem 0.25rem 1rem rgba(69, 91, 99, 0.1);

          &:nth-child(2n) {
            margin-right: 0;
          }

          &.active {
            background: #fbf4ea;
            border: 0.06rem solid #e2c993;
          }

          .card-list-item-icon {
            width: 3.13rem;
            height: 3.13rem;

            img {
              width: 3.13rem;
              height: 3.13rem;
            }
          }

          .card-info {
            font-size: 0.88rem;

            .card-t-1 {
              color: #2a2e43;
              margin-bottom: 0.13rem;
            }

            .card-t-2 {
              color: #78849e;
            }
          }
        }
      }
    }
  }
}
.agree {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7.5rem;
  .sumTotal {
    width: 10rem;
    height: 2rem;
    float: left;
    margin-left: 1.3rem;
    font-size: 0.8rem;
    .money {
      font-size: 0.8rem;
      font-weight: bold;
      color: #c29f55;
    }
    img {
      width: 1rem;
      height: 0.7rem;
      display: inline-block;
    }
  }
  .btn.disabled {
    background: #e1dfe0;
  }
  .btn {
    float: left;
    color: #2a2e43;
    font-size: 1.13rem;
    margin-left: 0.55rem;
    width: 10.5rem;
    height: 3.25rem;
    text-align: center;
    line-height: 3.25rem;
    font-weight: 400;
    border-radius: 2rem;
    background: linear-gradient(270deg, #e1bb73 0%, #f0ddb7 100%);
  }
}
.pop {
  font-size: 0.75rem;
  margin-left: 1.3rem;
  margin-top: 0.5rem;
  color: #666666;
}
</style>
